module.exports = __webpack_public_path__ + "img/pdf.1a731456.svg";